exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyable-form-control-button{width:58px}.copyable-form-control-message-container{height:12px;margin-top:3px}.copyable-form-control-message{display:none;font-size:12px;color:#468cc8;text-align:end}", ""]);

// exports
